import React, { MouseEventHandler, useEffect, useState } from "react";
import Button from "src/components/common/Button";
import IconButton from "../common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import { useAppDispatch } from "src/store/actions/action";
import { setRecentKeyword } from "src/store/reducers/asReduce";
import { setListData } from "src/store/reducers/noticeListReduce";

interface propsData {
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
  onClick2?: MouseEventHandler<HTMLButtonElement> | any;
}

const RecentKeyword = (props: propsData) => {
  const dispatch = useAppDispatch();

  // local_storage 설정으로
  const currentSearch: any = window.localStorage.getItem("currentSearch");

  const [init, setInit] = useState(true);

  let JsonData: Array<string> = [];
  if (currentSearch) {
    JsonData = JSON.parse(currentSearch);
  }
  const allDelete = () => {
    localStorage.setItem("currentSearch", "");
    setInit(init ? false : true);
  };

  const oneDelete = (e: React.MouseEvent, index: number) => {
    if (JsonData.length > 0) {
      JsonData.splice(index, 1);
      localStorage.setItem("currentSearch", JSON.stringify(JsonData));
    }
    setInit(init ? false : true);
  };

  const recentClick = (value: string) => {
    dispatch(setRecentKeyword(value));

    dispatch(
      setListData({
        keywordSearchData: value,
      }),
    );
  };

  return (
    <>
      {JsonData.length > 0 && (
        <KeywordSet>
          <p>최근검색어</p>

          <ButtonWrap>
            <Button
              variant="text"
              onClick={() => {
                allDelete(), props.onClick2 && props.onClick2();
              }}
            >
              모두 지우기
            </Button>
          </ButtonWrap>

          <KeywordList>
            {JsonData.map((v: string, idx: number) => {
              return (
                <li key={idx}>
                  <div>
                    <span onClick={() => recentClick(v)}>{v}</span>
                    <IconButton
                      btnName="키워드삭제"
                      onClick={(e) => {
                        oneDelete(e, idx), props.onClick && props.onClick(idx);
                      }}
                    >
                      <SVG name="keywordDel" width={20} height={20} viewBox="0 0 20 20" />
                    </IconButton>
                  </div>
                </li>
              );
            })}
          </KeywordList>
        </KeywordSet>
      )}
    </>
  );
};

const ButtonWrap = styled.div`
  padding-top: 7px;
  text-align: right;
  button {
    font-size: 14px;
  }
`;

const KeywordSet = styled.div`
  padding: 0 15px 15px;
  > p {
    font-size: 16px;
    font-weight: 700;
  }
`;

const KeywordList = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  min-width: 0;
  min-height: 0;
  margin-top: 15px;
  > li {
    overflow: hidden;
    display: inline-block;
    grid-column-end: span 1;
    grid-row-end: span 1;
    min-width: 0;
    padding: 15px 0;
    border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
    &:nth-child(2n-1) {
      padding-right: 10px;
    }
    &:nth-child(2n) {
      padding-left: 10px;
    }
    > div {
      ${({ theme }) => theme.flexBox.flexMixin()}
      > span {
        overflow: hidden;
        display: block;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
`;

export default RecentKeyword;
